





































































import moment from "moment";
import Modal from "../core/Modals/Modal.vue";
import Accordion from "../core/UI/Accordion.vue";
import CollapsiblePanel from "../core/UI/CollapsiblePanel.vue";
import { Email } from "../models/Email";

export default {
    name: "EntryMailsModal",
    components: { CollapsiblePanel, Accordion, Modal },
    props: {
        mails: {
            type: Array,
            default: () => [],
        },
        showModal: Boolean,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
        isIncoming(mail: any): boolean {
            return mail.type_id === Email.EEmailTypes.incoming;
        },
        formatDate(date: string): string {
            let parsed = moment(date);
            return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : "";
        },
        mailDocument(mail: any): string {
            return (
                '<!doctype html><html><head><meta charset="utf-8">' +
                '<base target="_blank"></head>' +
                '<body style="margin:16px;background:#fff;color:#000;font-family:Arial,Helvetica,sans-serif;font-size:13px;line-height:1.6">' +
                (mail.content || "") +
                "</body></html>"
            );
        },
    },
};
